import type { LinkProps } from 'next/link';
import Link from 'next/link';
import type { AnchorHTMLAttributes } from 'react';
import { forwardRef } from 'react';

type NextLinkProps = LinkProps & Omit<AnchorHTMLAttributes<HTMLAnchorElement>, keyof LinkProps>;

/**
 * This is a custom wrapper for next/link with prefetching disabled by default.
 */
export const NextLink = forwardRef<HTMLAnchorElement, NextLinkProps>((props, ref) => (
  // eslint-disable-next-line react/jsx-props-no-spreading
  <Link {...props} ref={ref} prefetch={props.prefetch ?? false} />
));
